import { loadView } from '@/router'

export default [
  {
    path: '/authentication',
    name: 'authentication',
    component: loadView('Authentication'),
    redirect: {
      name: 'authentication-signin'
    },
    children: [
      {
        path: 'sign-in',
        name: 'authentication-signin',
        component: loadView('Authentication/SignIn')
      },
      {
        path: 'sign-out',
        name: 'authentication-signout',
        component: loadView('Authentication/SignOut')
      },
      {
        path: 'forgot-password',
        name: 'authentication-forgotpassword',
        component: loadView('Authentication/ForgotPassword')
      },
      {
        path: 'reset-password',
        name: 'authentication-resetpassword',
        component: loadView('Authentication/ResetPassword')
      },
      {
        path: 'sso/:account',
        name: 'authentication-sso',
        component: loadView('Authentication/SSO')
      },
      {
        path: 'configure/sso',
        name: 'authentication-configure-sso',
        component: loadView('Authentication/ConfigureSSO')
      }
    ]
  }
]
